<div class="special_permissions">
  <!--The Heading sections (Heading + Serach )-->
  <div class="row heading-background mt-5">

    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-9">
      <h4>
        KPI Owner
      </h4>
    </div>
  </div>



  <!--List section-->

  <div class="custom_small_panelbody_fix">


    <div class="row checkbox">


      <mat-selection-list class="selectionList" [multiple]="true" (selectionChange)="onSelectRelatedSection($event)">
        @for (section of mersySections; track section) {
          <mat-list-option [value]="section" checkboxPosition="before">
            {{ section.Value }}
          </mat-list-option>
        }
      </mat-selection-list>
    </div>


  </div>


</div>



